import { render, staticRenderFns } from "./CostPricesConsignorPrices.vue?vue&type=template&id=28897644"
import script from "./CostPricesConsignorPrices.vue?vue&type=script&lang=js"
export * from "./CostPricesConsignorPrices.vue?vue&type=script&lang=js"
import style0 from "./CostPricesConsignorPrices.vue?vue&type=style&index=0&id=28897644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports